const mediaItems = [
  {
    title: '星辰大海·终极预告',
    type: '预告片',
    duration: '02:35',
    img: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20trailer%20scene%20with%20spaceship%20entering%20wormhole%2C%20dramatic%20space%20colors%2C%20cinematic%20lighting%2C%20film%20grain%20texture%2C%20widescreen%20format%2C%20high%20contrast%2C%20warm%20golden%20and%20deep%20blue%20tones&width=600&height=400&seq=media-01&orientation=landscape',
  },
  {
    title: '暗夜追光·独家花絮',
    type: '花絮',
    duration: '04:12',
    img: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20set%20with%20cameras%20and%20lighting%20equipment%2C%20director%20talking%20to%20actors%2C%20warm%20set%20lighting%2C%20professional%20film%20production%2C%20cinematic%20atmosphere%2C%20golden%20hour%20tones&width=600&height=400&seq=media-02&orientation=landscape',
  },
  {
    title: '欢乐喜剧人·名场面合集',
    type: '精选',
    duration: '08:20',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20comedy%20show%20stage%20with%20bright%20spotlights%2C%20performers%20on%20stage%2C%20audience%20laughing%2C%20festive%20atmosphere%2C%20warm%20vibrant%20lighting%2C%20entertainment%20photography%2C%20energetic%20mood&width=600&height=400&seq=media-03&orientation=landscape',
  },
  {
    title: '山海传说·制作特辑',
    type: '特辑',
    duration: '06:45',
    img: 'https://readdy.ai/api/search-image?query=Animation%20studio%20with%20artists%20working%20on%20digital%20tablets%2C%20character%20design%20sketches%20on%20walls%2C%20warm%20studio%20lighting%2C%20creative%20workspace%2C%20Chinese%20art%20style%20elements%2C%20professional%20environment&width=600&height=400&seq=media-04&orientation=landscape',
  },
  {
    title: '本周必看·观影指南',
    type: '指南',
    duration: '05:18',
    img: 'https://readdy.ai/api/search-image?query=Modern%20living%20room%20with%20large%20TV%20screen%20showing%20movie%20poster%20grid%2C%20cozy%20evening%20atmosphere%2C%20warm%20ambient%20lighting%2C%20home%20cinema%20setup%2C%20comfortable%20furniture%2C%20cinematic%20mood&width=600&height=400&seq=media-05&orientation=landscape',
  },
];

export default function SectionMedia() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精彩预告
          </h2>
          <p className="text-sm text-foreground-500">热门影视精彩预告与花絮抢先看</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-lg overflow-hidden border border-background-200 group cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/90 group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-primary-600 group-hover:text-white text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-white text-xs rounded">
                  {item.duration}
                </span>
                <span className="absolute top-2 left-2 px-2 py-0.5 bg-accent-500 text-white text-xs rounded">
                  {item.type}
                </span>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-medium text-foreground-900 line-clamp-1">{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}